import { api } from '@/services';
import Vue from 'vue';

const URL = '/processo/declaracaoImportacao';

function buildURLSearchParams(payload) {
  const params = new URLSearchParams();

  Object.keys(payload).forEach((key) => {
    const value = payload[key];
    if (Array.isArray(value)) {
      params.append(key, value.join(','));
    } else if (typeof value === 'object' && value !== null) {
      Object.keys(value).forEach((subKey) => {
        params.append(`${key}${subKey.charAt(0).toUpperCase() + subKey.slice(1)}`, value[subKey]);
      });
    } else if (value) {
      params.append(key, value);
    }
  });

  return params;
}

export default {
  async fetchDeclaracaoImportacaoByCodigoDI({ commit }, payload) {
    const response = await api.get(`${URL}/processo/${payload.codigoProcesso}/filial/${payload.filial}/di/${payload.codigoDI}/itens`);
    commit('SET_ITEM_BY_CODIGO_DECLARACAO_IMPORTACAO', response.data);
  },
  async fetchDeclaracaoImportacaoItems({ commit, dispatch }, payload) {
    const params = buildURLSearchParams(payload);

    dispatch('toggleLoading', true, { root: true });

    try {
      const { data } = await api.get(URL, { params });

      commit('SET_DECLARACAO_IMPORTACAO_TABLE_ITEMS', data.data);
      commit('paginacao/SET_PAGINADOR', data, { root: true });
    } catch (e) {
      Vue.$toast.clear();
      Vue.$toast.error('Não foi possível buscar os dados da tabela');
    }

    dispatch('toggleLoading', false, { root: true });
  },
  async filtrar({ commit }, payload) {
    commit('SET_FILTROS', payload);
  },
  async prepararExcel() {
    try {
      const { data } = await api.get(`${URL}/excel`);
      if (!data.data) return null;

      const excelFormatado = data.data.map((res) => ({
        codigoDI: res.codigoDI,
        referenciaCliente: res.referenciaCliente,
        referenciaTrust: res.referenciaTrust,
        ncm: res.ncm,
        produto: res.produto,
        pesoLiquido: res.pesoLiquido,
        quantidade: res.quantidade,
        valor: res.valor,
        moedaInvoice: res.moedaInvoice,
        dataRegistro: res.dataRegistro,
        descricaoCompleta: res.descricaoCompleta,
      }));

      return excelFormatado;
    } catch (e) {
      Vue.$toast.clear();
      Vue.$toast.error('Não foi possível gerar o arquivo Excel');
    }

    return null;
  },
};
